module.exports = __webpack_public_path__ + "static/media/Almacenamiento y despacho.5b13c838.svg";